
import { useState, useEffect, createContext, useContext } from 'react';
import { CsuiteRole, PERSONA_CONFIGS, PersonaConfig } from '@/types/personas';

interface PersonaContextType {
  currentPersona: CsuiteRole;
  setPersona: (persona: CsuiteRole) => void;
  personaConfig: PersonaConfig;
  getAllPersonas: () => PersonaConfig[];
}

export const PersonaContext = createContext<PersonaContextType | undefined>(undefined);

export function usePersona() {
  const context = useContext(PersonaContext);
  if (!context) {
    throw new Error('usePersona must be used within a PersonaProvider');
  }
  return context;
}

export function usePersonaState() {
  const [currentPersona, setCurrentPersona] = useState<CsuiteRole>(() => {
    const saved = localStorage.getItem('selected-persona');
    return (saved as CsuiteRole) || 'CSO';
  });

  const setPersona = (persona: CsuiteRole) => {
    setCurrentPersona(persona);
    localStorage.setItem('selected-persona', persona);
  };

  const personaConfig = PERSONA_CONFIGS[currentPersona];

  const getAllPersonas = () => Object.values(PERSONA_CONFIGS);

  return {
    currentPersona,
    setPersona,
    personaConfig,
    getAllPersonas
  };
}
